// id's should correspond with ScorePath's defined on the backend
// Rankings category renamed to Search with a subcategory Ranking
module.exports = {
  "total": "Overall",
  "reviews": "Reviews",
  "reviews.providers": "Provider Settings",
  "reviews.response": "Response",
  "reviews.rating": "Rating",
  "reviews.growth": "Growth",
  "reviews.sentiment": "Sentiment",
  "listings": "Listings",
  "listings.providers": "Provider Settings",
  "listings.accuracy": "NAP Accuracy",
  "listings.url": "Website Accuracy",
  "listings.duplicates": "No Listing Duplicates",
  "rankings": "Search",
  "rankings.search": "Rankings",
  "rankings.search.providers": "Provider Settings",
  "rankings.search.web": "Web Rankings",
  "rankings.search.local": "Local Rankings",
  "rankings.insights": "Insights",
  "social": "Social",
  "social.posts": "Posts",
  "social.fans": "Fans",
  "social.tags": "Tags",
  "competitors": "Competitors",
  "competitors.reviews": "Review Rating Comparison",
  "competitors.responses": "Review Responding Comparison",
  "competitors.social": "Social Fan Comparison"
};
